// Global JavaScript for Vogal Theme - Mobile First

// Mobile Menu Handler
class MobileMenu {
  constructor() {
    this.toggle = document.querySelector('.header__menu-toggle');
    this.nav = document.querySelector('.header__nav');
    this.overlay = document.querySelector('.header__overlay');
    this.body = document.body;
    
    this.init();
  }

  init() {
    if (this.toggle) {
      this.toggle.addEventListener('click', () => this.toggleMenu());
    }
    
    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.closeMenu());
    }

    // Close menu on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.nav.classList.contains('active')) {
        this.closeMenu();
      }
    });

    // Close menu on resize to desktop
    window.addEventListener('resize', () => {
      if (window.innerWidth >= 1024 && this.nav.classList.contains('active')) {
        this.closeMenu();
      }
    });
  }

  toggleMenu() {
    const isActive = this.nav.classList.contains('active');
    
    if (isActive) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }

  openMenu() {
    this.nav.classList.add('active');
    this.overlay.classList.add('active');
    this.toggle.classList.add('active');
    this.body.style.overflow = 'hidden';
  }

  closeMenu() {
    this.nav.classList.remove('active');
    this.overlay.classList.remove('active');
    this.toggle.classList.remove('active');
    this.body.style.overflow = '';
  }
}

class CartDrawer {
  constructor() {
    this.drawer = document.querySelector('.cart-drawer');
    this.overlay = document.querySelector('.cart-drawer__overlay');
    this.closeBtn = document.querySelector('.cart-drawer__close');
    this.cartIcon = document.querySelector('.header__icon--cart');
    
    this.init();
  }

  init() {
    if (this.cartIcon) {
      this.cartIcon.addEventListener('click', () => this.open());
    }
    
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.close());
    }
    
    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.close());
    }
  }

  open() {
    if (this.drawer && this.overlay) {
      this.drawer.classList.add('active');
      this.overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  }

  close() {
    if (this.drawer && this.overlay) {
      this.drawer.classList.remove('active');
      this.overlay.classList.remove('active');
      document.body.style.overflow = '';
    }
  }
}

// Category Filter Functionality
class CategoryFilter {
  constructor() {
    this.filterBtns = document.querySelectorAll('.category-filter-btn');
    this.init();
  }

  init() {
    this.filterBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        this.filterBtns.forEach(b => b.classList.remove('active'));
        e.target.classList.add('active');
        
        const category = e.target.dataset.category;
        this.filterProducts(category);
      });
    });
  }

  filterProducts(category) {
    const products = document.querySelectorAll('.product-card');
    
    products.forEach(product => {
      if (category === 'all') {
        product.style.display = 'block';
      } else {
        const productCategory = product.dataset.category;
        product.style.display = productCategory === category ? 'block' : 'none';
      }
    });
  }
}

// Quick View Modal
class QuickView {
  constructor() {
    this.quickViewBtns = document.querySelectorAll('.quick-view-btn');
    this.init();
  }

  init() {
    this.quickViewBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const productHandle = btn.dataset.productHandle;
        this.openQuickView(productHandle);
      });
    });
  }

  openQuickView(handle) {
    // Quick view modal logic
    console.log('Opening quick view for:', handle);
  }
}

// Search Functionality
class SearchDrawer {
  constructor() {
    this.searchIcon = document.querySelector('.header__icon--search');
    this.init();
  }

  init() {
    if (this.searchIcon) {
      this.searchIcon.addEventListener('click', () => {
        // Open search drawer or redirect to search page
        window.location.href = '/search';
      });
    }
  }
}

// Smooth Scroll
function smoothScroll() {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (href !== '#') {
        e.preventDefault();
        const target = document.querySelector(href);
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }
    });
  });
}

// Smooth Scroll to Top Button
class ScrollToTop {
  constructor() {
    this.createButton();
    this.init();
  }

  createButton() {
    const button = document.createElement('button');
    button.className = 'scroll-to-top';
    button.innerHTML = '↑';
    button.setAttribute('aria-label', 'Scroll to top');
    document.body.appendChild(button);
    this.button = button;
  }

  init() {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 500) {
        this.button.classList.add('visible');
      } else {
        this.button.classList.remove('visible');
      }
    });

    this.button.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }
}

// Add loading animation for images
class ImageLazyLoad {
  constructor() {
    this.images = document.querySelectorAll('img[data-src]');
    this.init();
  }

  init() {
    const options = {
      root: null,
      rootMargin: '50px',
      threshold: 0.01
    };

    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          img.src = img.dataset.src;
          img.classList.add('loaded');
          observer.unobserve(img);
        }
      });
    }, options);

    this.images.forEach(img => imageObserver.observe(img));
  }
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  new MobileMenu();
  new CartDrawer();
  new CategoryFilter();
  new QuickView();
  new SearchDrawer();
  new ScrollToTop();
  smoothScroll();
  
  // Add animation on scroll
  const animateOnScroll = () => {
    const elements = document.querySelectorAll('.section');
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
        }
      });
    }, {
      threshold: 0.1
    });

    elements.forEach(el => observer.observe(el));
  };
  
  animateOnScroll();
});

// Sticky header
window.addEventListener('scroll', () => {
  const header = document.querySelector('.header');
  if (window.scrollY > 100) {
    header.classList.add('header--sticky');
  } else {
    header.classList.remove('header--sticky');
  }
});

